"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('ring-one', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("g", {
    stroke: "none",
    strokeWidth: props.strokeWidth,
    fill: "none",
    fillRule: "evenodd"
  }, _react.default.createElement("g", null, _react.default.createElement("g", {
    transform: "translate(1.000000, 1.000000)",
    stroke: props.outStrokeColor,
    strokeLinejoin: props.strokeLinejoin,
    strokeWidth: props.strokeWidth
  }, _react.default.createElement("circle", {
    fill: props.outFillColor,
    fillRule: "nonzero",
    cx: "23",
    cy: "6.63636364",
    r: "3.63636364"
  }), _react.default.createElement("circle", {
    fill: props.outFillColor,
    fillRule: "nonzero",
    cx: "23",
    cy: "39.3636364",
    r: "3.63636364"
  }), _react.default.createElement("circle", {
    fill: props.outFillColor,
    fillRule: "nonzero",
    cx: "6.63636364",
    cy: "23",
    r: "3.63636364"
  }), _react.default.createElement("circle", {
    fill: props.outFillColor,
    fillRule: "nonzero",
    cx: "39.3636364",
    cy: "23",
    r: "3.63636364"
  }), _react.default.createElement("path", {
    d: "M31.7339848,9.15964782 C33.7916707,10.460881 35.539119,12.2083293 36.8403522,14.2660152 M36.8403522,31.7339848 C35.539119,33.7916707 33.7916707,35.539119 31.7339848,36.8403522 M14.2660152,36.8403522 C12.2083293,35.539119 10.460881,33.7916707 9.15964782,31.7339848 M9.15964782,14.2660152 C10.460881,12.2083293 12.2083293,10.460881 14.2660152,9.15964782",
    strokeLinecap: props.strokeLinecap
  })))));
});

exports.default = _default;